export default "__VITE_ASSET__DlONm_RU__"